import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import {axiosInstance as axios} from "../../utils/axios"
import {HeaderModel} from "../../models/headerModel"
import HeaderApiConfig from "../../config/api/headerdata"
import defaultHeaderData from "./defaultHeaderData"
import {REALM_HEADER} from "../../config/constants"

// this will always be called server-side on first render and subsequent server-side renders
export const getHeaderData = async (
    headers: IncomingHttpHeaders,
    defaultHeaderVersion: string,
    headerName: string,
): Promise<HeaderModel> => {
    try {
        const getHeaderDataApi = HeaderApiConfig("getHeaderData")
        const response = await axios({
            method: getHeaderDataApi.method,
            url: `${getHeaderDataApi.localEndpoint(headerName)}`,
            headers: headers as {
                [header: string]: string
            },
        })

        return response.data
    } catch (error) {
        const ex = error as Error
        logger.error("Failed to load the header api: ", ex as any)
        const defaultData = await Promise.resolve(
            defaultHeaderData(headers[REALM_HEADER], defaultHeaderVersion, headerName),
        )
        return defaultData
    }
}
